/* Toggle navigation drawer */
document.addEventListener("DOMContentLoaded", function() {
  const hb = document.querySelector('.hb');
  const navDrawer = document.querySelector('.navigation-drawer');

  hb.addEventListener('click', function() {
    navDrawer.classList.toggle('active');
  });
});


/* Toggle submenus on nav-drawer */
// Prepend back button to sub menu(s)
$('.navigation-drawer__sub').prepend('<li class="navigation-drawer__item navigation-drawer__back"><a class="navigation-drawer__link back navigation-drawer__sub-close" href="#"><svg class="navigation-drawer__icon"><use xlink:href="#icon-chevron-left" /></svg> Back</a></li>');

// Close out sub menu
$('.navigation-drawer__sub-close').click(function(e) {
  e.preventDefault();
  $(this).parent().parent().removeClass('is-active');
});

// Trigger sub menu
$('.has-sub-menu .navigation-drawer__link').click(function(e) {
  e.preventDefault();
  $(this).siblings().addClass('is-active');
});

/* Get header and footer heights */
window.onload = function() {
  const header = document.querySelector('.cor-header');
  const footer = document.querySelector('.cor-footer');

  if (header && footer) {
    const html = document.documentElement;
    const headerHeight = header.offsetHeight;
    const footerHeight = footer.offsetHeight;

    html.style.setProperty('--header-height', `${headerHeight}px`);
    html.style.setProperty('--footer-height', `${footerHeight}px`);
  } else {
    console.warn('Divs with classes "cor-header" and "cor-footer" not found.');
  }
};